import { STORY_BIBLE_KEYS } from "../../../../../src/shared/schemas/PluginSchema";

export const PROMPT_1_RESULT_NAME = "prompt_1_result";

const formatVariableLabel = (variable) => variable
  .split("_")
  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
  .join(" ");

export const variableLabel = (variable) => {
  if (variable === "user_text_input") {
    return "User Instructions";
  } else if (variable === "highlighted_text") {
    return "Selected Text";
  } else if (variable === PROMPT_1_RESULT_NAME) {
    return "Step 1 Result";
  } else if (variable === "previous_document_text") {
    return "Previous Document Text";
  } else if (variable === "scene_summary") {
    return "Chapter Summary";
  }

  return formatVariableLabel(variable);
};

export const variableDescription = (variable) => {
  if (variable === "highlighted_text") {
    return "Document text the user has selected. You can specify how much or how little text to include.";
  } else if (variable === "preceding_text") {
    return "Document text immediately preceding the cursor. You can specify how much or how little text to include.";
  } else if (variable === "following_text") {
    return "Document text immediately after the cursor. You can specify how much or how little text to include.";
  } else if (variable === "previous_document_text") {
    return "Document text from earlier linked documents. You can specify how much or how little text to include.";
  } else if (variable === "user_text_input") {
    return "Instructions entered by the user.";
  } else if (variable === PROMPT_1_RESULT_NAME) {
    return "Output generated by Prompt 1.";
  } else if (STORY_BIBLE_KEYS.includes(variable)) {
    if (variable === "scene_summary") {
      return "The section of the outline linked with the current document, if any.";
    } else if (variable === "chapter_beats") {
      return "The beats associated with the current document, if any.";
    } else if (variable === "is_story_bible_active") {
      return "Whether or not story bible is toggled on.";
    } else if (variable === "characters") {
      return "The characters from the story bible, optimized by the Saliency engine.";
    } else if (variable === "characters_raw") {
      return "The characters from the story bible, raw, unoptimized.";
    } else if (variable === "worldbuilding") {
      return "The worldbuilding entries from the story bible, optimized by the Saliency engine.";
    } else if (variable === "worldbuilding_raw") {
      return "The worldbuilding entries from the story bible, raw, unoptimized.";
    } else if (variable === "chapter_scenes") {
      return "The scenes associated with the current chapter, if any.";
    } else if (variable === "chapter_scenes_extra_instructions") {
      return "Extra instructions for how to write the chapter (based on the chapter_scenes).";
    } else {
      return `The ${variable} from the story bible.`;
    }
  } else {
    return "";
  }
};
